import { useState } from 'react'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'

interface LeaveLoyalinkRedirectModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	onContinue: () => void
	onCancel: () => void
}

export function LeaveLoyalinkRedirectModal({ open, setOpen, onContinue, onCancel }: LeaveLoyalinkRedirectModalProps) {
	return (
		<ConfirmationModal
			open={open}
			setOpen={setOpen}
			title="You're Leaving Loyalink"
			onConfirm={onContinue}
			onCancel={onCancel}
			confirmLabel="Continue"
			cancelLabel="Cancel"
			hideCloseButton={true}
		>
			<p className="text-primary-text">
				You&apos;re about to be redirected to an external website to complete this event action. Loyalink does
				not control the content or experience on external sites.
			</p>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface LeaveLoyalinkRedirectModalManagedProps {
	onContinue: () => void
	onCancel?: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'leave-loyalink-redirect': LeaveLoyalinkRedirectModalManagedProps
	}
}

export function ManagedLeaveLoyalinkRedirectModal({
	onClose,
	onContinue,
	onCancel,
}: LeaveLoyalinkRedirectModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<LeaveLoyalinkRedirectModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onContinue={() => { onContinue(); handleClose() }}
			onCancel={() => { onCancel?.(); handleClose() }}
		/>
	)
}
